import { styled } from 'styles';

export const PanelContent = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
});

export const TabItemContainer = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  position: 'relative',
});

export const AbsolutePosition = styled('div', {
  position: 'absolute',
  inset: 0,
  overflowY: 'scroll',
  padding: 16,
  '@md': {
    padding: 20,
  },
});
